export const NEW_VERSION_DETECTED = 'NEW_VERSION_DETECTED'
export const RESET_SYSTEM_ACTION = 'RESET_SYSTEM_ACTION'
export const SET_DOCUMENT_TITLE = 'SET_DOCUMENT_TITLE'
// Mutations
export const CHANGE_VERSION = 'CHANGE_VERSION'
export const RESET_SYSTEM = 'RESET_SYSTEM'
export const SAVE_DOCUMENT_TITLE = 'SAVE_DOCUMENT_TITLE'



// WEBPACK FOOTER //
// ./src/store/actions/system.js